export default "__VITE_ASSET__1FtEgd0P__";